import React, { useState, useEffect } from "react";
import { Grid, Card, Typography, Box, Avatar, Skeleton } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const LocationCard = ({ title, type, locations, isLoading, onLocationClick }) => {

    const renderSkeletons = () => {
        return Array.from({ length: 6 }).map((_, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "20px",
                        backgroundColor: "#eaf7f7",
                        borderRadius: "10px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        border: "1px solid #5ebaba",
                        minHeight: "100px",
                    }}
                >
                    <Skeleton
                        variant="circular"
                        width={60}
                        height={60}
                        sx={{ marginRight: "15px", backgroundColor: "#d4f2f2" }}
                    />
                    <Skeleton
                        variant="text"
                        width="70%"
                        height={30}
                        sx={{ backgroundColor: "#d4f2f2" }}
                    />
                </Card>
            </Grid>
        ));
    };

    return (
        <Box sx={{ padding: "40px", backgroundColor: "#f8f9fa" }}>
            <Typography
                variant="h4"
                component="h2"
                align="left"
                sx={{ marginBottom: "20px", fontSize: "60px" }}
                dangerouslySetInnerHTML={{ __html: title }}
            />

            <Grid container spacing={3} justifyContent="start">
                {isLoading
                    ? renderSkeletons()
                    : locations.length === 0
                        ? (
                            <Typography align="center" variant="h6">
                                No locations found.
                            </Typography>
                        )
                        : locations.map((location) => (
                            <Grid item xs={12} sm={6} md={4} key={location._id}>
                                <Card
                                    onClick={() => onLocationClick(type, location)}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: "20px",
                                        backgroundColor: "#eaf7f7",
                                        borderRadius: "10px",
                                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                        border: "1px solid #5ebaba",
                                        minHeight: "100px",
                                        cursor: 'pointer'
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            backgroundColor: "#5ebaba",
                                            marginRight: "15px",
                                            width: "60px",
                                            height: "60px",
                                        }}
                                    >
                                        <LocationOnIcon sx={{ color: "white", fontSize: "40px" }} />
                                    </Avatar>
                                    <Typography
                                        variant="p"
                                        component="p"
                                        sx={{
                                            fontSize: "20px",
                                            whiteSpace: "nowrap", // Prevent overflowing text
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            width: "100%", // Limit width for ellipsis effect
                                        }}
                                    >
                                        {type === 1 ? location?.mainLocation : location?.title}
                                    </Typography>
                                </Card>
                            </Grid>
                        ))}
            </Grid>
        </Box>
    );
};

export default LocationCard;
